import { SOCKET_RECEIVED } from "../actionTypes";

export interface WebsocketProps {
  type?: "getWsStatus" | "sendMsg";
  status?: boolean;
  path?: string;
  content?: any;
}

const initialState: WebsocketProps = {
  type: "getWsStatus",
  status: false,
  path: "",
  content: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SOCKET_RECEIVED: {
      const content = action.payload;
      return content;
    }

    default:
      return state;
  }
}
